import React, {useEffect, useState} from "react";
import I18n from 'i18n.js.erb'
import {isDefined} from "../../utils/utils";

const AddressForm = ({
    shipmentAddress,
    updateShipmentAddressParams,
    countries,
    canUpdate,
    addressType,
    formSubmitted,
    hideEmail
  }) => {

  const [ provinces, setProvinces ] = useState([])

  // console.log('countries: ', countries);
  // console.log('shipmentAddress: ', shipmentAddress);

  useEffect(() => {
    if (isDefined(countries) && isDefined(shipmentAddress?.country_id) && isDefined(countries[shipmentAddress.country_id]) && isDefined(countries[shipmentAddress.country_id]['provinces'])) {
      setProvinces(countries[shipmentAddress.country_id]['provinces']);
      if (isDefined(shipmentAddress?.province) && !countries[shipmentAddress.country_id]['provinces'].includes(shipmentAddress.province))
        updateShipmentAddressParams(['province'], ['']);
    }
    else {
      setProvinces([]);
      updateShipmentAddressParams(['province'], ['']);
    }
  }, [shipmentAddress.country_id]);

  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return (
    <React.Fragment>
      <form className="w-100">
        <div className="row">
          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.firstName')}<sup>*</sup></p>
            <input
              type="text"
              disabled={!canUpdate}
              className={`form-control mb-2 ${(formSubmitted && shipmentAddress.first_name?.trim()?.length < 2) && 'border-aiG-red-imp'}`}
              value={shipmentAddress.first_name}
              placeholder={I18n.t('js.newUserAddressForm.firstNamePlaceholder')}
              onChange={(e) => updateShipmentAddressParams(['first_name'], [e.target.value])}
            />
          </div>

          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.lastName')}<sup>*</sup></p>
            <input
              type="text"
              disabled={!canUpdate}
              className={`form-control mb-2 ${(formSubmitted && addressType === 'user' && shipmentAddress.last_name?.trim()?.length < 2) && 'border-aiG-red-imp'}`}
              value={shipmentAddress.last_name}
              placeholder={I18n.t('js.newUserAddressForm.lastNamePlaceholder')}
              onChange={(e) => updateShipmentAddressParams(['last_name'], [e.target.value])}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.co')}</p>
            <input
              type="text"
              disabled={!canUpdate}
              className="form-control mb-2"
              value={shipmentAddress.co ? shipmentAddress.co : ''}
              placeholder={I18n.t('js.newUserAddressForm.coPlaceholder')}
              onChange={(e) => updateShipmentAddressParams(['co'], [e.target.value])}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.country')}<sup>*</sup></p>
            <select
              id={"new_address_country_id"}
              className={`form-control mb-2 ${(formSubmitted && !isDefined(shipmentAddress.country_id)) && 'border-aiG-red-imp'}`}
              disabled={!canUpdate}
              value={shipmentAddress.country_id ? shipmentAddress.country_id : ''}
              onChange={(e) => {
                updateShipmentAddressParams(['country_id', 'country'], [e.target.value, isDefined(e.target.value) ? countries[e.target.value].name : '']);
              }}>
              <option id="empty_country" value="">
                {I18n.t('js.newUserAddressForm.countryPlaceholder')}
              </option>
              {
                Object.entries(countries)
                  .sort(([countryId1, countryData1], [countryId2, countryData2]) => countryData1.name < countryData2.name ? -1 : 0)
                  .map(([countryId, countryData]) => {
                    return <option id={countryId} value={countryId} key={countryId}>
                      {countryData.name}
                    </option>
                })
              }
            </select>
          </div>

          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.province')}<sup>*</sup></p>
            <select
              id={"new_address_province"}
              className={`form-control mb-2 ${(formSubmitted && shipmentAddress.province?.trim()?.length < 2) && 'border-aiG-red-imp'}`}
              disabled={!canUpdate}
              value={shipmentAddress.province}
              onChange={(e) => updateShipmentAddressParams(['province'], [e.target.value])}>
              <option id="empty_province" value="">
                {I18n.t('js.newUserAddressForm.provincePlaceholder')}
              </option>
              {
                provinces.map((province) => {
                  return <option id={province} value={province} key={province}>
                    {province}
                  </option>
                })
              }
            </select>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.city')}<sup>*</sup></p>
            <input
              type="text"
              disabled={!canUpdate}
              className={`form-control mb-2 ${(formSubmitted && shipmentAddress.city?.trim()?.length < 3) && 'border-aiG-red-imp'}`}
              value={shipmentAddress.city}
              placeholder={I18n.t('js.newUserAddressForm.cityPlaceholder')}
              onChange={(e) => updateShipmentAddressParams(['city'], [e.target.value])}
            />
          </div>

          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.postalCode')}<sup>*</sup></p>
            <input
              type="number"
              disabled={!canUpdate}
              className={`form-control mb-2 ${(formSubmitted && shipmentAddress.cap?.trim()?.length < 1) && 'border-aiG-red-imp'} hide-arrows-number`}
              value={shipmentAddress.cap}
              placeholder={I18n.t('js.newUserAddressForm.postalCodePlaceholder')}
              onChange={(e) => updateShipmentAddressParams(['cap'], [e.target.value])}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.street')}<sup>*</sup></p>
            <input
              type="text"
              disabled={!canUpdate}
              className={`form-control mb-2 ${(formSubmitted && shipmentAddress.street_square?.trim()?.length < 3) && 'border-aiG-red-imp'}`}
              value={shipmentAddress.street_square}
              placeholder={I18n.t('js.newUserAddressForm.streetPlaceholder')}
              onChange={(e) => updateShipmentAddressParams(['street_square'], [e.target.value])}
            />
          </div>

          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.number')}<sup>*</sup></p>
            <input
              type="text"
              disabled={!canUpdate}
              className={`form-control mb-2 ${(formSubmitted && shipmentAddress.number?.trim()?.length < 1) && 'border-aiG-red-imp'}`}
              value={shipmentAddress.number}
              placeholder={I18n.t('js.newUserAddressForm.numberPlaceholder')}
              onChange={(e) => updateShipmentAddressParams(['number'], [e.target.value])}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.indoor')}</p>
            <input
              type="text"
              disabled={!canUpdate}
              className="form-control mb-2"
              value={shipmentAddress.indoor ? shipmentAddress.indoor : ''}
              placeholder={I18n.t('js.newUserAddressForm.indoorPlaceholder')}
              onChange={(e) => updateShipmentAddressParams(['indoor'], [e.target.value])}
            />
          </div>

          <div className="col-12 col-md-6">
            <p className="mb-0">{I18n.t('js.newUserAddressForm.phoneNumber')}<sup>*</sup></p>
            <input
              type="number"
              disabled={!canUpdate}
              className={`form-control mb-2 ${(formSubmitted && addressType === 'user' && (!shipmentAddress.phone_number || shipmentAddress.phone_number.replaceAll(' ', '').trim()?.length < 9)) && 'border-aiG-red-imp'} hide-arrows-number`}
              value={shipmentAddress.phone_number ? shipmentAddress.phone_number : ''}
              placeholder={I18n.t('js.newUserAddressForm.phoneNumberPlaceholder')}
              onChange={(e) => updateShipmentAddressParams(['phone_number'], [e.target.value])}
            />
          </div>

          {
            !hideEmail &&
              <div className="col-12 col-md-6">
                <p className="mb-0">{I18n.t('js.newUserAddressForm.email')}</p>
                <input
                  type="text"
                  disabled={!canUpdate}
                  className={`form-control mb-2 ${(formSubmitted && addressType === 'user' && (!shipmentAddress.email || !regex.test(shipmentAddress.email.trim()))) && 'border-aiG-red-imp'}`}
                  value={shipmentAddress.email ? shipmentAddress.email : ''}
                  placeholder={I18n.t('js.newUserAddressForm.emailPlaceholder')}
                  onChange={(e) => updateShipmentAddressParams(['email'], [e.target.value])}
                />
              </div>
          }

          <div className="col-12 py-4 d-flex">
            <input
              type="checkbox"
              className="cursor-pointer residenceCheckbox"
              id="residenceCheckbox"
              value={shipmentAddress.residence ? 1 : 0}
              checked={shipmentAddress.residence === true}
              onChange={(e) => updateShipmentAddressParams(['residence'], [!shipmentAddress.residence])}
            />
            &nbsp;
            <label className="ml-1 mb-0 cursor-pointer font-weight--normal" htmlFor="residenceCheckbox">
              {I18n.t('js.newUserAddressForm.residence')}<br/>
              <small>{I18n.t('js.newUserAddressForm.residenceExplanation')}</small>
            </label>
          </div>
        </div>
      </form>
    </React.Fragment>
  );
};

export default AddressForm;